import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=1c95614e&"
import script from "./Screen.vue?vue&type=script&lang=js&"
export * from "./Screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c95614e')) {
      api.createRecord('1c95614e', component.options)
    } else {
      api.reload('1c95614e', component.options)
    }
    module.hot.accept("./Screen.vue?vue&type=template&id=1c95614e&", function () {
      api.rerender('1c95614e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/ok-customer/components/Screen.vue"
export default component.exports